import React, { useEffect, useState } from "react";
import { Endpoints } from "../constants/env/middletier";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';

function SubstituteGroupsViewer({ onGetPhoneNumbers }) {
  const [groups, setGroups] = useState([]);
  const [groupsList, setGroupsList] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedGroupSubs, setSelectedGroupSubs] = useState(null);
  const [loading, setLoading] = useState(true);
    const [selectedSubs, setSelectedSubs] = useState(null);

  // Fetch all groups on mount
  useEffect(() => {
    async function fetchGroups() {
      try {
        const res = await fetch(Endpoints["getsubgroups"]);
        const data = await res.json();
        setGroups(data);
        console.log("Data Groups");
        console.log(data);

        const mappedGroups = data.map((dataGroups) => (dataGroups.groupName));
        setGroupsList(mappedGroups);
      } catch (err) {
        console.error("Failed to load groups", err);
      } finally {
        setLoading(false);
      }
    }
    fetchGroups();
  }, []);

  const handleGroupChange = (e) => {
    const groupName = e.target.value;
    const group = groups.find((g) => g.groupName === groupName);
    setSelectedGroup(e.value);
    setSelectedGroupSubs(group.substitutes);
  };

    const setPhoneNumbers = (e) => {
        setSelectedSubs(e.value)
        onGetPhoneNumbers(e.value);
    }


  if (loading) return <div>Loading data...</div>;

  return (
    <>
      <h2>Substitute Groups</h2>

      {/* Dropdown List */}
      {/* Substitutes Table */}
        <div className="card flex justify-content-center">
            <Dropdown
                value={selectedGroup}
                onChange={handleGroupChange}
                options={groupsList}
                optionLabel="name"
                placeholder="Select a Group" />
        </div>


          {selectedGroup && (
                  <div className="card flex flex-wrap justify-content-center gap-3">
                      <DataTable value={selectedGroupSubs} selectionMode={null} selection={selectedSubs}
                        onSelectionChange={setPhoneNumbers} dataKey="id" tableStyle={{ minWidth: '50rem' }}>
                          <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                          <Column field="fullName" header="Name"></Column>
                          <Column field="phone" header="Phone"></Column>
                      </DataTable>
                  </div>
          )}
    </>
  );
}

export default SubstituteGroupsViewer;
